$(document).ready(function () {
    $('#sidebarCollapse').on('click', function () {
        $('#sidebar').toggleClass('active');
        $('#sidebar').toggleClass('fix');
        $('#sidebarCollapse').toggleClass('fix');
        $('.navbar').toggleClass('margin-active'); /* added */
        $('#subcontent').toggleClass('margin-active'); /* added */
        $('.footer').toggleClass('margin-active'); /* added */

        $('.faFree').toggleClass('d-block');
        $('.faFix').toggleClass('d-none');

        $('.faFix').toggleClass('d-block');
        $('.faFree').toggleClass('d-none');
    });

    $('#sidebar').on('mouseenter', function () {
		if(!$('#sidebar').hasClass('fix')) {
        	$('#sidebar').removeClass('active'); /* modified */
            $('.navbar').removeClass('margin-active'); /* added */
            $('#subcontent').removeClass('margin-active'); /* added */
            $('.footer').removeClass('margin-active'); /* added */
        }
    });

    $('#sidebar').on('mouseleave', function () {
        if(!$('#sidebar').hasClass('fix')) {
        	$('#sidebar').addClass('active'); /* modified */
            $('.navbar').addClass('margin-active'); /* added */
            $('#subcontent').addClass('margin-active'); /* added */
            $('.footer').addClass('margin-active'); /* added */
        }
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });
});
